import { render, staticRenderFns } from "./ViewReceipt.vue?vue&type=template&id=2c700e5b&"
import script from "./ViewReceipt.vue?vue&type=script&lang=js&"
export * from "./ViewReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ViewReceipt.vue?vue&type=style&index=0&id=2c700e5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports